module.exports = __webpack_public_path__ + "static/media/vlc.da58bd30.png";